<template>
  <div class="mita">
    <a :href="mitaClubPagePath"><img class="mitaclub-banner" :src="imgPath"/></a>
  </div>
</template>

<script>
export default {
  props: {
    fromPage: {
      type: String,
      default: 'home',
    },
  },
  computed: {
    imgPath() {
      if (this.$md.mobile() && !this.$md.tablet())
        return 'https://file.midlandici.com/mr/img/mitaclub/2023/mita_banner_mobile.png';
      return 'https://file.midlandici.com/mr/img/mitaclub/2023/mita_banner.png';
    },
    mitaClubPagePath() {
      return `${window.SITE_URL}mitaclub`;
    },
  },
};
</script>

<style scoped>
.mita img {
  width: 100%;
  display: block;
}
</style>
